// Footer
import { makeYear } from '../utilities/dateMaker';
import { APP_AUTHOR } from '../globals/variables';

const Footer = () => (

    <footer className="footer">
        <p className="copyright">&copy; {APP_AUTHOR} {makeYear()}.</p>
    </footer>

);

export default Footer;